import type { User } from '@/types/api';
import { useCurrentUserQuery } from './useCurrentUserQuery';

function userHasSuperAdminRole(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.role?.permissions?.some((p) => p.name === 'Super_Admin')) return true;
  // Multi-company: virtual `role` is taken from one membership; prefer any membership with Super_Admin.
  return (user.memberships ?? []).some((m) => m.role?.permissions?.some((p) => p.name === 'Super_Admin'));
}

export function useSuperAdmin() {
  const { data: currentUser } = useCurrentUserQuery();

  return {
    isSuperAdmin: userHasSuperAdminRole(currentUser ?? null),
    currentUser,
  };
}
